import React from 'react';

import { FormikCheckbox } from '~commonInfra/components/FormikCheckbox';
import { Messages } from '~src/codegen/Localize';
import { openReactConfirmationDialog } from '~src/commonInfra/dialogs/ReactConfirmationDialog';
import { TabDialogWidth } from '~src/commonInfra/dialogs/style/TabDialogWidth';
import { SettingsFormikValues } from '~src/settings/components/common/SettingsFormikContainer';
import { SettingsSection } from '~src/settings/components/common/SettingsSection';
import { useFormikContext } from '~src/settings/FormikWrapperForStubbing';
import { componentRegistryEntry } from '~src/settings/general-settings/components/SettingsComponentRegistryFunctions';
import { ISiteAdminSettings } from '~src/settings/types/ISiteSettingsForSiteAdmin';

export const PACKAGES_ADMIN_SETTINGS_SECTION_TEST_ID = 'packages-admin-settings-section';
export const PACKAGES_ENABLED_CHECKBOX_TEST_ID = 'packages-enabled';
export const PACKAGES_ALLOW_POPUPS_CHECKBOX_TEST_ID = 'packages-allow-popups';

export function PackagesAdminSettingsSection(): React.ReactElement {
  const { values } = useFormikContext<SettingsFormikValues<ISiteAdminSettings>>();
  const packagesEnabled = values?.settings?.siteSettingsV2?.packagesEnabled === true;

  const beforeChangeEnabled = React.useCallback(
    (event: React.ChangeEvent<HTMLInputElement>): Promise<void> => {
      if (event.target.checked) {
        return Promise.resolve();
      }
      return openReactConfirmationDialog({
        title: Messages.packages_settings_turnOff_title(),
        message: Messages.packages_settings_turnOff_message(),
        actionName: Messages.packages_settings_turnOff_action(),
        paramsForAction: undefined,
        action: () => Promise.resolve(),
        dialogWidth: TabDialogWidth.width500px,
      }).result.then(() => undefined);
    },
    []
  );

  return (
    <SettingsSection title={Messages.packages_tab_title()} testId={PACKAGES_ADMIN_SETTINGS_SECTION_TEST_ID}>
      <FormikCheckbox
        label={Messages.packages_settings_enabledLabel()}
        name={'settings.siteSettingsV2.packagesEnabled'}
        testId={PACKAGES_ENABLED_CHECKBOX_TEST_ID}
        beforeChange={beforeChangeEnabled} />
      <FormikCheckbox
        label={Messages.packages_settings_allowPopupsLabel()}
        name={'settings.siteSettingsV2.packagesAllowPopups'}
        testId={PACKAGES_ALLOW_POPUPS_CHECKBOX_TEST_ID}
        disabled={!packagesEnabled} />
    </SettingsSection>
  );
}

export const PackagesAdminSettingsSectionSpecs = componentRegistryEntry({
  name: 'PackagesAdminSettingsSection',
  component: PackagesAdminSettingsSection,
});
